import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";

export const PressStrip = () => {
  const { t } = useLanguage();

  return (
    <section id="press" data-testid="press-strip-section" className="py-14 md:py-20 border-b border-foreground/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal>
          <p
            data-testid="press-strip-label"
            className="text-center text-xs md:text-sm uppercase tracking-[0.3em] text-foreground/70"
          >
            {t.press.label}
          </p>
          <ul
            data-testid="press-outlets-list"
            className="mt-8 md:mt-10 flex flex-wrap items-baseline justify-center gap-x-3 gap-y-4 md:gap-x-4 max-w-4xl mx-auto"
          >
            {t.press.outlets.map((outlet, i) => (
              <li key={i} className="flex items-baseline gap-3 md:gap-4">
                {i > 0 && (
                  <span aria-hidden="true" className="text-foreground/25 text-sm">
                    ·
                  </span>
                )}
                <span
                  data-testid={`press-outlet-${i + 1}`}
                  className="font-normal text-base md:text-lg tracking-wide text-foreground/60 whitespace-nowrap"
                >
                  {outlet}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
